import Message from './index.vue';

// 定义插件对象
const __Message__ = {};
// vue的install方法，用于定义vue插件
__Message__.install = function(Vue, options) {
  const __Message__Instance = Vue.extend(Message);
  let current;
  const initInstance = () => {
    // 实例化vue实例
    current = new __Message__Instance();
    let __Message__El = current.$mount().$el;
    document.body.appendChild(__Message__El);
  };
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$message = {
    /**
     * 成功消息
     * @param {Boolean} options.showIcon 是否展示图标
     * @param {Boolean} options.showIconColored 是否展示图标颜色
     * @param {String} options.message 消息内容
     * @param {Number} options.duration 消息展示时间（毫秒）
     * @param {String} options.position 消息展示位置
     * @returns 返回当前组件对象实例，可调用 Close 方法关闭消息框
     */
    success(options) {
      if (!current) {
        initInstance();
      }
      return current.fnSuccess(options);
    },
    /**
     * 提示消息
     * @param {Boolean} options.showIcon 是否展示图标
     * @param {Boolean} options.showIconColored 是否展示图标颜色
     * @param {String} options.message 消息内容
     * @param {Number} options.duration 消息展示时间（毫秒）
     * @param {String} options.position 消息展示位置
     * @returns 返回当前组件对象实例，可调用 Close 方法关闭消息框
     */
    info(options) {
      if (!current) {
        initInstance();
      }
      return current.fnInfo(options);
    },
    /**
     * 警示消息
     * @param {Boolean} options.showIcon 是否展示图标
     * @param {Boolean} options.showIconColored 是否展示图标颜色
     * @param {String} options.message 消息内容
     * @param {Number} options.duration 消息展示时间（毫秒）
     * @param {String} options.position 消息展示位置
     * @returns 返回当前组件对象实例，可调用 Close 方法关闭消息框
     */
    warning(options) {
      if (!current) {
        initInstance();
      }
      return current.fnWarning(options);
    },
    /**
     * 错误消息
     * @param {Boolean} options.showIcon 是否展示图标
     * @param {Boolean} options.showIconColored 是否展示图标颜色
     * @param {String} options.message 消息内容
     * @param {Number} options.duration 消息展示时间（毫秒）
     * @param {String} options.position 消息展示位置
     * @returns 返回当前组件对象实例，可调用 Close 方法关闭消息框
     */
    error(options) {
      if (!current) {
        initInstance();
      }
      return current.fnError(options);
    }
  };
  Vue.prototype.$closeMessage = () => {
    if (current) {
        current.Close();
    }
  };
};
export default __Message__;
